import React from 'react';

const DetailItem = ({ icon: Icon, label, value }) => (
    <div className='flex flex-row items-start gap-1 w-[25%]'>
        {Icon && <Icon className='mt-[2px]' />}
        <div className='flex flex-col gap-1 pe-3'>
            <span className='font-inter text-sm font-normal text-gray600'>{label}:</span>
            <span className='font-inter text-sm font-medium text-textPrimary capitalize'>{value}</span>
        </div>
    </div>
);

export { DetailItem };
